import { InformationUniversal, VideoFrame, YellowSlots } from '@app/entities/infoMessages';
import { ModalOilAcea } from '@modals/ModalOilAcea';
import { ModalOilApi } from '@modals/ModalOilApi';
import { ModalOilViscosity } from '@modals/ModalOilViscosity';
import { ModalShops } from '@modals/ModalShops';
import { PayOneClick } from '@modals/PayOneClick';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import {
  selectModal,
  selectPopupData,
  setCheckedRegion,
  setCookiesPopup,
  setMessage,
  setMessage23,
  setMessage9,
  setModalVideoWhyChoose,
  setNewYear,
} from '@redux/slices/modalWindow';
import { BlockCookies } from '@sharedComponents/BlockCookies';
import { useEffect } from 'react';
import { ModalAkbSpecs } from './Modals/ModalAkbSpecs';

import dynamic from 'next/dynamic';
import ScrollToTop from 'react-scroll-to-top';
import Cookies from 'universal-cookie';

import { ConnectModalFastOrder } from '@features/fastOrder';

import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';
import { InfoMessagePromotion } from '@entities/infoMessages/ui/InfoMessagePromotion';

import styles from './LayoutModal.module.scss';

const CityModal = dynamic(() => import('./Modals/CityModal'), { ssr: false });
const ModalFreeTyres = dynamic(() => import('./Modals/FreeTyres'), {
  ssr: false,
});
const InfoCookies = dynamic(() => import('./Modals/InfoCookies'), {
  ssr: false,
});
const ModalTyresSize = dynamic(() => import('./Modals/ModalTyresSize'), {
  ssr: false,
});
const ModalTyresWidth = dynamic(() => import('./Modals/ModalTyresWidth'), {
  ssr: false,
});
const ModalTyresHeight = dynamic(() => import('./Modals/ModalTyresHeight'), {
  ssr: false,
});
const ModalTyresDiameter = dynamic(() => import('./Modals/ModalTyresDiameter'), { ssr: false });
const ModalTyresRunFlat = dynamic(() => import('./Modals/ModalTyresRunFlat'), {
  ssr: false,
});
const ModalTyresCommercial = dynamic(() => import('./Modals/ModalTyresCommercial'), { ssr: false });
const ModalDisksDiameter = dynamic(() => import('./Modals/ModalDisksDiameter'), { ssr: false });
const ModalDisksFasteningPCD = dynamic(() => import('./Modals/ModalDisksFasteningPCD'), { ssr: false });
const ModalDisksType = dynamic(() => import('./Modals/ModalDisksType'), {
  ssr: false,
});
const ModalVideo = dynamic(() => import('./Modals/ModalVideo'), { ssr: false });

export const LayoutModal = () => {
  const dispatch = useAppDispatch();
  const {
    modalRegion,
    modalFreeTyres,
    modalCookiesInfo,
    background,
    modalTyresSize,
    modalTyresWidth,
    modalTyresHeight,
    modalTyresDiameter,
    modalTyresRunFlat,
    modalTyresCommercial,
    modalDisksDiameter,
    modalDisksFasteningPCD,
    modalDisksType,
    activeVideo,
    modalPayClick,
    modalShopList,
    modalAkbSpec,
    modalOilViscosity,
    modalOilApi,
    modalOilAcea,
    modalVideoWhyChoose,
  } = useAppSelector(selectModal);
  const { popupCookies } = useAppSelector(selectPopupData);
  const cookies = new Cookies();
  useEffect(() => {
    if (background) {
      document.body.classList.add('lock');
    } else {
      document.body.classList.remove('lock');
    }
  }, [background]);

  useEffect(() => {
    if (cookies.get('CheckedRegion') === 'hide') {
      dispatch(setCheckedRegion(false));
    } else {
      dispatch(setCheckedRegion(true));
    }
    if (cookies.get('kolesoNewYearMessage') === 'hide') {
      dispatch(setNewYear(false));
    } else {
      dispatch(setNewYear(true));
    }
    if (cookies.get('koleso23Fev') === 'hide') {
      dispatch(setMessage23(false));
    } else {
      dispatch(setMessage23(true));
    }
    if (cookies.get('hideFixedFooterPrivateDataPolicy') === '1') {
      dispatch(setCookiesPopup(false));
    } else {
      dispatch(setCookiesPopup(true));
    }
    if (cookies.get('careMessageInfo') === 'hide') {
      dispatch(setMessage(false));
    } else {
      dispatch(setMessage(true));
    }
    if (cookies.get('koleso9May') === 'hide') {
      dispatch(setMessage9(false));
    } else {
      dispatch(setMessage9(true));
    }
  }, []);

  return (
    <ErrorBoundaryComponent>
      {modalRegion && <CityModal />}
      {modalFreeTyres && <ModalFreeTyres />}
      {modalTyresSize && <ModalTyresSize />}
      {modalTyresWidth && <ModalTyresWidth />}
      {modalTyresHeight && <ModalTyresHeight />}
      {modalTyresDiameter && <ModalTyresDiameter />}
      {modalTyresRunFlat && <ModalTyresRunFlat />}
      {modalTyresCommercial && <ModalTyresCommercial />}
      {modalDisksDiameter && <ModalDisksDiameter />}
      {modalDisksFasteningPCD && <ModalDisksFasteningPCD />}
      {modalDisksType && <ModalDisksType />}
      {modalCookiesInfo && <InfoCookies />}
      {popupCookies && <BlockCookies />}
      {activeVideo && <ModalVideo video={activeVideo} />}
      {modalPayClick && <PayOneClick />}
      {modalShopList && <ModalShops />}
      {modalAkbSpec && <ModalAkbSpecs />}
      {modalOilViscosity && <ModalOilViscosity />}
      {modalOilApi && <ModalOilApi />}
      {modalOilAcea && <ModalOilAcea />}
      {/* <WeatherAlert /> */}
      <YellowSlots />
      <InfoMessagePromotion />
      {/* <OilChangeFree /> */}
      <InformationUniversal />
      {/* <RefillAirConditioner/> */}
      {/* <VideoWhyChoose/> */}
      {/* InfoJob /> */}
      {modalVideoWhyChoose && <VideoFrame isOpen={modalVideoWhyChoose} onClose={() => dispatch(setModalVideoWhyChoose())} />}
      {/* <ModalPickUpStoreWrapper/> */}
      <ConnectModalFastOrder />
      {/* <February23rdNotice */}
      {/*  pages={['/shops', '/shops/[slug]']} */}
      {/*  cookieName={'cookie_name_february23'} */}
      {/*  content={'23 февраля наши шинные центры работают с 9 до 18. С праздником!'} */}
      {/* /> */}
      {/* {Message9 && <Message close={() => dispatch(setMessage9(false))} />} */}
      <ScrollToTop viewBox="-200 -200 650 650" className={styles.arrow_up} color="white" />
    </ErrorBoundaryComponent>
  );
};
